.banner {
  position: relative;
  width: 100%;
  border-radius: 12px;
  border: 1px solid rgba(204, 255, 0, 0.35);
  background: rgba(204, 255, 0, 0.07);
}

.content {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 44px 14px 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
}

/* 44×44 so a thumb can dismiss the banner (BUG-19: it was 28×28); the icon stays small. */
.close {
  position: absolute;
  top: 0;
  right: 0;
  width: var(--gac-control-touch-target);
  height: var(--gac-control-touch-target);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
}
